
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { MemberService } from 'src/app/component/members/member-service/member.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../../assigntrips-service/assigntrips-service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-planner-template-add',
  templateUrl: './planner-template-add.component.html',
  styleUrls: ['./planner-template-add.component.css']
})
export class PlannerTemplateAddComponent implements OnInit, OnDestroy {
  searchControl = new FormControl('');
  templateForm: FormGroup
  assignForm: FormGroup
  members: any[] = [];
  skip = 0;
  submitted = false;
  assignFormSubmitted = false;
  user;
  driverList = [];
  preDriverList = {}
  preMembersList = {};
  templateId;
  newTemplateEntry = []

  constructor(
    private memberService: MemberService,
    private fb: FormBuilder,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.templateId = params["id"];
      });
    this.getUser();

    this.templateForm = this.fb.group({
      title: ['', Validators.required],
      status: ['active', Validators.required],
      mappers: [[]]
    });

    this.assignForm = this.fb.group({
      members: [[], Validators.required],
      driver: ['', Validators.required]
    })

    if (this.templateId) {
      this.getTemplateById();
    }

  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.loadPatients();
          this.search();
          this.getDriverList();
        }
      });
  }

  getTemplateById() {
    this.assignTripService.getTemplateById(this.templateId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.templateForm.patchValue({
            ...data
          })

          this.getMembers();
        }
      })
  }

  getMembers() {
    let members = new Set();
    this.templateForm.value.mappers.forEach(group => {
      if (group.members) {
        group.members.forEach(member => members.add(member));
      }
    });

    const payload = {
      _ids: Array.from(members),
      accountStatus: 'active'
    };
    this.assignTripService
      .getTemplateMembersnew(payload)
      .subscribe(data => {
        if (data) {

          this.preMembersList = {
            ...this.preMembersList,
            ...data.reduce((obj, item) => (obj[item._id] = item, obj), {})
          }
        }
      });
  }

  addTemplate() {
    this.submitted = true;

    if (this.assignForm.invalid) {
      return;
    }

    let item = this.templateForm.value.mappers.find(
      (template) => template.driver === this.assignForm.value.driver
    );

    if (item && item.driver) {
      const updatedMembers = Array.from(new Set([...item.members, ...this.assignForm.value.members]));
      item.members = updatedMembers;
    } else {
      const newTemplate = this.assignForm.value;
      item = {
        driver: newTemplate.driver,
        members: newTemplate.members
      };
      this.templateForm.value.mappers.push(item);
    }

    this.newTemplateEntry = [item];

    this.assignForm.patchValue({
      members: [],
      driver: ''
    });
    this.submitted = false;
    this.newTemplateEntry = [];
  }


  editDriver(templateItem) {

    const template = this.templateForm.value.mappers.find(
      (template) => template.driver === templateItem.driver
    );
    this.assignForm.patchValue(template);
    this.newTemplateEntry = [template];

  }


  // Remove Member from the Driver's Template
  removeMember(templateItem, memberItem) {
    let index = this.templateForm.value.mappers.findIndex(
      (template) => template.driver === templateItem.driver
    );

    const updatedMembers = this.templateForm.value.mappers[index].members.filter(
      (member) => member !== memberItem
    );
    this.templateForm.value.mappers[index].members = updatedMembers;

    if (this.assignForm.value.driver === templateItem.driver) {
      this.assignForm.patchValue({
        members: updatedMembers
      });

      this.newTemplateEntry = [this.templateForm.value.mappers[index]];

    }


  }

  removeTemplate(templateItem) {
    let index = this.templateForm.value.mappers.findIndex(
      (template) => template.driver === templateItem.driver
    );
    this.templateForm.value.mappers.splice(index, 1);

    if (this.assignForm.value.driver === templateItem.driver) {
      this.assignForm.reset();
      this.assignForm.patchValue({
        driver: '',
        members: []
      });

      this.newTemplateEntry = [];
    }

  }


  search() {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap((term) => {
          console.log("Data check", term);
          this.skip = 0;  // Reset skip for new search
          this.members = [];  // Clear current patients
          const payload = {
            skip: this.skip,
            displayName: term
          }
          return this.memberService.getMembers2(payload);
        })
      )
      .subscribe((patients) => {
        this.members = patients;
      });
  }

  loadPatients(): void {
    const queryParam = {
      accountStatus: 'active',
      skip: this.skip,
    }
    this.memberService.getMembers2(queryParam)
      .subscribe((newPatients) => {
        this.preMembersList = {
          ...this.preMembersList,
          ...newPatients.reduce((obj, item) => (obj[item._id] = item, obj), {})
        };
        this.members = [...this.members, ...newPatients];
        this.skip += newPatients.length;
      });
  }


  onScroll(): void {
    // Check if there are more patients to load
    this.loadPatients();  // Load more patients
  }

  onSearch(term: any): void {
    console.log(term)
    this.searchControl.setValue(term.term);
  }


  get form() {
    return this.templateForm.controls;
  }

  get form2() {
    return this.assignForm.controls;
  }




  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
          this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }


  onSubmit() {
    this.submitted = true;
    if (this.templateForm.invalid || this.templateForm.value.mappers.length === 0) {
      this.assignFormSubmitted = true;
      return;
    }
    const payload = this.templateForm.value;
    console.log(payload);
    this.assignTripService.addPlannerTemplate(payload, this.templateId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.router.navigateByUrl('/planner/template')
        }
      })
  }

  ngOnDestroy(): void {

  }

  onDriverChange(evt) {
    if (evt) {
      const template = this.templateForm.value.mappers.find(
        (template) => template.driver === evt
      );
      if (template) {
        this.assignForm.patchValue(template);
        this.newTemplateEntry = [template];
        return;
      }
    }

    this.assignForm.patchValue({
      members: []
    });
    this.newTemplateEntry = [];

  }


}
